<template>
  <div class="main" :style="mainBackgroundStyle">
    <!-- 右上角大棚选择 -->
    <div class="greenhouse-select">
      <el-select
        v-model="selectedGreenhouseId"
        placeholder="选择大棚"
        size="mini"
        clearable
        filterable
        @change="handleGreenhouseChange"
        style="width: 220px"
      >
        <el-option
          v-for="item in greenhouseOptions"
          :key="item.value"
          :label="item.label"
          :value="item.value"
        />
      </el-select>
    </div>
    <!-- 预览模式遮罩，禁止所有操作 -->
    <div v-if="isPreviewMode" class="preview-mask" @click.stop>
      <div class="preview-close" @click.stop="closePreview">关闭预览</div>
    </div>
    <Header />

    <div ref="centerbox" class="centerbox" :style="centerboxPreviewStyle">
      <!-- 预览模式下的设备显示 -->
      <template v-if="previewConfig && previewConfig.placedDevices">
        <div
          v-for="device in previewConfig.placedDevices"
          :key="device.id"
          class="preview-device-item"
          :class="{ 'is-active': isDeviceActive(device.id) }"
          :style="getPreviewDeviceStyle(device)"
          @click="handlePreviewDeviceClick(device)"
        >
          <div
            :class="[
              'device-label',
              {
                'long-name': isLongDeviceName(device.name),
                'is-offline': isDeviceOffline(device),
              },
            ]"
          >
            {{ device.name }}
          </div>
          <img
            :src="getPreviewDeviceImage(device)"
            :alt="device.name"
            class="device-icon"
          />
        </div>
      </template>

      <!-- 非预览模式：根据后台设备坐标(bgXY)渲染 -->
      <template v-else>
        <div
          v-for="device in positionedDevices"
          :key="device.id"
          class="preview-device-item"
          :class="{ 'is-active': isDeviceActive(device.id) }"
          :style="getNonPreviewDeviceStyle(device)"
          @click="handlePreviewDeviceClick(device)"
        >
          <div
            :class="[
              'device-label',
              {
                'long-name': isLongDeviceName(device.name),
                'is-offline': isDeviceOffline(device),
              },
            ]"
          >
            {{ device.name }}
          </div>
          <img
            :src="getNonPreviewDeviceImage(device)"
            :alt="device.name"
            class="device-icon"
          />
        </div>
      </template>
      <div
        v-if="showdetailtitle"
        ref="detailDialog"
        class="tipbox"
        :style="detailDialogStyle"
      >
        <div class="tiptop">
          {{ showdetailtitle
          }}<span :style="{ color: detailvalue.online ? '#04FF9F' : 'red' }">{{
            detailvalue.online ? "(在线)" : "(离线)"
          }}</span>
          <div class="closebtn" @click="closedialog">×</div>
        </div>
        <div
          class="tipcontent"
          :style="{
            fontSize: detailvalue.deviceName == 'B区气象站' ? '15px' : '16px',
          }"
        >
          <div v-if="detailLoading" class="tiploading">
            <i class="el-icon-loading"></i>
            <span>数据加载中...</span>
          </div>
          <template v-else>
            <div
              class="tipvalueitem"
              v-for="item in valueedlist"
              :key="item.name"
            >
              {{ item.name }}:<span class="value"
                >{{ detailvalue[item.value] }}{{ item.unit }}</span
              >
            </div>
          </template>
        </div>
        <div class="uptime">
          <div class="time">更新时间：{{ detailvalue.time || "" }}</div>
          <div class="more" @click="godetail(showdetailtitle)">
            <el-button type="primary" size="mini">查看更多 >></el-button>
          </div>
        </div>
      </div>
      <svg
        v-if="dialogline.visible"
        class="tipline"
        :viewBox="`0 0 ${centerboxSize.width} ${centerboxSize.height}`"
        preserveAspectRatio="none"
      >
        <polyline :points="dialogline.points" />
        <circle
          v-if="dialogline.points"
          :cx="dialogline.endPoint.x"
          :cy="dialogline.endPoint.y"
          r="4"
        />
        <circle
          v-if="dialogline.points"
          :cx="dialogline.startPoint.x"
          :cy="dialogline.startPoint.y"
          r="5"
          class="tipline-start"
        />
      </svg>
    </div>
    <div class="bottombox">
      <div class="blbox">
        <div class="title">
          <div class="txt">在线监测</div>
          <div class="time">
            更新时间：{{ (sbcount[0] && sbcount[0].time) || "" }}
          </div>
          <div class="btns">
            <div
              :class="ptype == '棚内' ? 'btnitem btned' : 'btnitem'"
              @click="ptypeclick('棚内')"
            >
              棚内
            </div>
            <div
              :class="ptype == '棚外' ? 'btnitem btned' : 'btnitem'"
              @click="ptypeclick('棚外')"
            >
              棚外
            </div>
          </div>
        </div>
        <div class="contentbox">
          <div class="zxitem" v-for="(item, index) in sbcount" :key="index">
            <div class="zxitem_left">
              <img :src="sbcounticons[item.device_type]" />
              <div>{{ item.device_type }}</div>
            </div>
            <div class="zxitem_right">
              <div class="statustxt" @click="godetail(item.device_type)">
                在线
              </div>
              <div class="statusnum" @click="godetail(item.device_type)">
                {{ item.normal }}
              </div>
              <div class="statustxt">离线</div>
              <div class="statusnum t2">{{ item.abnormal }}</div>
            </div>
          </div>
        </div>
      </div>
      <div class="bcbox">
        <div class="title ctitle">
          <div>
            &nbsp;&nbsp;AI预警和任务
            <img
              v-if="audioing"
              id="play"
              src="@/assets/img/home/audio.png"
              @click="readans"
            />
            <img
              v-else
              id="play"
              src="@/assets/img/home/unaudio.png"
              @click="readans"
            />
            <audio id="ansaudio" :src="audiourl" style="display: none" />
          </div>
          <el-button type="primary" size="mini" @click="gowarn"
            >查看更多 >></el-button
          >
        </div>
        <div class="contentbox">
          <table>
            <tr>
              <th style="width: 80px">业务场景</th>
              <th>AI推送详情</th>
              <th style="width: 130px">设备状态</th>
              <th style="width: 100px">运行时间(秒)</th>
              <th style="width: 120px">状态变更时间</th>
            </tr>
            <template v-if="tabledata.length">
              <tr v-for="(item, index) in tabledata" :key="index">
                <td>{{ item.type }}</td>
                <td style="text-align: left; padding-left: 10px">
                  <p style="margin-bottom: 5px">{{ item.createTime }}</p>
                  {{ item.content }}
                </td>
                <td>
                  <div class="statusbtn btn0">{{ item.status || "-" }}</div>
                </td>
                <td>
                  <span v-if="index == 0 && item.isRead == 0 && countdown > 0"
                    >倒计时{{ countdown }}s</span
                  >
                  <span v-else>{{ item.time }}s</span>
                </td>
                <td>
                  <span>{{ item.statusTime }}</span>
                </td>
              </tr>
            </template>
            <tr v-else class="ai-warning-placeholder-row">
              <td colspan="5">
                <div class="ai-warning-placeholder">暂无AI预警和任务</div>
              </td>
            </tr>
          </table>
        </div>
      </div>
      <div class="brbox">
        <div class="title">
          实时监控<img
            @click="govideopage"
            src="../assets/img/home/scall.png"
          />
        </div>
        <div class="contentbox">
          <iframe
            v-if="monitorUrl"
            style="width: 100%; height: 100%"
            :src="monitorUrl"
          />
          <div v-else class="monitor-placeholder">
            暂无实时监控，请先配置该大棚监控
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import router from "../router";
import axios from "@/axios";
import { baseUrl } from "@/axios/baseUrl";
import Header from "./Header.vue";

import {
  getsbcount,
  getwarlist,
  setreadstatus,
  getonlinelist,
} from "@/api/bot";
export default {
  name: "index",
  components: {
    Header,
  },
  data() {
    return {
      menu: 0,
      ptype: "棚内",
      // 预览配置（从设备位置编辑器传入）
      previewConfig: null,
      // Header实际高度（Header.vue中headermain的高度是78px）
      headerHeight: 78,
      // 设计稿基准尺寸（固定参考尺寸，用于计算缩放比例）
      designWidth: 1920,
      designHeight: 1080,

      // 非预览模式：默认背景与设备数据
      defaultBg: null,
      allDevices: [],

      showdetailtitle: "",
      currentDevice: null, // 当前选中的设备信息
      audiolang: 0,
      audiourl: "",
      timer: null,
      timer2: null,
      dialogstyle: {
        left: 0,
        right: 0,
        top: 0,
        bottom: 0,
        icon: "",
        transform: null,
      },
      dialogline: {
        visible: false,
        points: "",
        startPoint: { x: 0, y: 0 },
        endPoint: { x: 0, y: 0 },
      },
      detailLoading: false,
      detailRequestId: 0,
      valuekeylist: {
        4: [
          {
            name: "温度",
            value: "temp",
            unit: "℃",
          },
          {
            name: "湿度",
            value: "humi",
            unit: "%",
          },
          {
            name: "二氧化碳",
            value: "co2",
            unit: "ppm",
          },
          {
            name: "光照",
            value: "light",
            unit: "Lux",
          },
        ],
        2: [
          {
            name: "含氮量",
            value: "nitrogen",
            unit: "mg/kg",
          },
          {
            name: "含磷量",
            value: "phosphorus",
            unit: "mg/kg",
          },
          {
            name: "含钾量",
            value: "potassium",
            unit: "mg/kg",
          },
        ],
        3: [
          {
            name: "含水率",
            value: "water",
            unit: "%RH",
          },
          {
            name: "温度",
            value: "temp",
            unit: "℃",
          },
          {
            name: "电导率",
            value: "conductivity",
            unit: "us/cm",
          },
        ],
        1: [
          {
            name: "PH值",
            value: "ph",
            unit: "",
          },
        ],
        5: [
          {
            name: "风力",
            value: "windRank",
            unit: "级",
          },
          {
            name: "风速",
            value: "windSpeed",
            unit: "m/s",
          },
          {
            name: "风向",
            value: "windDirection",
            unit: "",
          },
          {
            name: "温度",
            value: "temp",
            unit: "℃",
          },
          {
            name: "湿度",
            value: "humi",
            unit: "%",
          },
          {
            name: "光照",
            value: "light",
            unit: "",
          },
          {
            name: "大气压",
            value: "pressure",
            unit: "kPa",
          },
          {
            name: "累计雨量",
            value: "rainfall",
            unit: "mm",
          },
          {
            name: "瞬时雨量",
            value: "instantRainfall",
            unit: "mm",
          },
          {
            name: "当前雨量",
            value: "currentRainfall",
            unit: "mm",
          },
          {
            name: "日雨量",
            value: "yesterdayRainfall",
            unit: "mm",
          },
        ],
      },
      valueedlist: [],
      detailvalue: {},
      onlinelist: {},
      sbcount: [],
      audioing: true,
      countdown: 0,
      timeoutId: null,
      sbcounticons: {
        土壤温湿度EC传感器: require("../assets/img/home/zxitemimg1.png"),
        土壤PH传感器: require("../assets/img/home/zxitemimg2.png"),
        土壤氮磷钾传感器: require("../assets/img/home/zxitemimg3.png"),
        大气环境监测传感器: require("../assets/img/home/zxitemimg4.png"),
        棚外气象站: require("../assets/img/home/zxitemimg4.png"),
      },
      tabledata: [],
      // 大棚选择
      greenhouseOptions: [],
      selectedGreenhouseId: "",
      monitorUrl: "",
      // 画布点击高亮
      activeDeviceId: null,
      // 全屏状态
      isFullscreen: false,
    };
  },
  computed: {
    // 判断是否是预览模式
    isPreviewMode() {
      return this.previewConfig && this.previewConfig.backgroundImageUrl;
    },
    // 主背景图样式（预览模式）
    mainBackgroundStyle() {
      // 关键：背景图和设备容器必须使用相同的宽高比计算基准
      // 这样才能确保设备相对于背景图的位置在全屏/非全屏时保持一致
      const viewportWidth = window.innerWidth;
      const viewportHeight = window.innerHeight;
      
      // 使用设计稿的宽高比 (1920:1080 = 16:9)
      const designRatio = this.designWidth / this.designHeight;
      const viewportRatio = viewportWidth / viewportHeight;
      
      // 根据宽高比计算实际使用的参考尺寸（与 centerboxPreviewStyle 保持一致）
      let referenceWidth, referenceHeight;
      if (viewportRatio > designRatio) {
        // 视口更宽，以高度为基准
        referenceHeight = viewportHeight;
        referenceWidth = referenceHeight * designRatio;
      } else {
        // 视口更高，以宽度为基准
        referenceWidth = viewportWidth;
        referenceHeight = referenceWidth / designRatio;
      }
      
      if (this.isPreviewMode) {
        return {
          backgroundImage: `url(${this.previewConfig.backgroundImageUrl})`,
          backgroundSize: `${referenceWidth}px ${referenceHeight}px`,
          backgroundPosition: "center",
          backgroundRepeat: "no-repeat",
          width: "100%",
          height: "100%",
          minHeight: "100vh",
        };
      }
      // 非预览模式使用默认背景
      if (this.defaultBg && this.defaultBg.imgUrl) {
        return {
          backgroundImage: `url(${this.defaultBg.imgUrl})`,
          backgroundSize: `${referenceWidth}px ${referenceHeight}px`,
          backgroundPosition: "center",
          backgroundRepeat: "no-repeat",
          width: "100%",
          height: "100%",
          minHeight: "100vh",
        };
      }
      // 非预览模式，返回空对象，使用CSS中的默认背景色
      return {};
    },
    // centerbox 样式（预览与非预览统一使用同一套定位与缩放规则）
    centerboxPreviewStyle() {
      // 关键：使用固定的设计稿宽高比来计算，而不是实际视口尺寸
      // 这样在全屏/非全屏切换时，设备的相对位置保持不变
      const viewportWidth = window.innerWidth;
      const viewportHeight = window.innerHeight;
      
      // 使用设计稿的宽高比 (1920:1080 = 16:9)
      const designRatio = this.designWidth / this.designHeight;
      const viewportRatio = viewportWidth / viewportHeight;
      
      // 根据宽高比计算实际使用的参考尺寸
      let referenceWidth, referenceHeight;
      if (viewportRatio > designRatio) {
        // 视口更宽，以高度为基准
        referenceHeight = viewportHeight;
        referenceWidth = referenceHeight * designRatio;
      } else {
        // 视口更高，以宽度为基准
        referenceWidth = viewportWidth;
        referenceHeight = referenceWidth / designRatio;
      }

      const headerHeight = this.headerHeight || 78;
      const contentHeight = referenceHeight - headerHeight;

      // 与编辑视图保持一致的比例关系
      const originalBgHeight = 594;
      const originalHeight = 374; // centerbox 高度
      const heightPercent = originalHeight / originalBgHeight; // 约62.96%

      const previewTop = headerHeight;
      const previewHeight = heightPercent * contentHeight;
      const previewWidth = referenceWidth;
      const previewLeft = (viewportWidth - referenceWidth) / 2; // 居中

      return {
        position: "absolute",
        left: `${previewLeft}px`,
        top: `${previewTop}px`,
        width: `${previewWidth}px`,
        height: `${previewHeight}px`,
        boxSizing: "border-box",
        zIndex: 10,
      };
    },
    // 参与渲染的设备（非预览模式）
    positionedDevices() {
      if (!this.selectedGreenhouseId) return [];
      return this.allDevices
        .filter(
          (d) => String(d.greenhouseId) === String(this.selectedGreenhouseId)
        )
        .map((d) => {
          const { x, y } = this.parseBgXY(d.bgXY);
          return {
            id: d.id,
            name: d.name || d.deviceName,
            deviceName: d.deviceName || d.name,
            x,
            y,
            classify: d.classify,
            onlineStatus:
              d.onlineStatus !== undefined ? d.onlineStatus : d.online,
          };
        })
        .filter((d) => d.x != null && d.y != null);
    },
    detailDialogStyle() {
      const style = {
        left: this.dialogstyle.left || "50%",
        top: this.dialogstyle.top || "50%",
        transform: this.dialogstyle.transform || "",
      };
      if (this.dialogstyle.icon) {
        style.backgroundImage = `url(${this.dialogstyle.icon})`;
        style.backgroundSize = "100% 100%";
      }
      return style;
    },
    centerboxSize() {
      const centerbox = this.$refs.centerbox;
      if (!centerbox) {
        return { width: 0, height: 0 };
      }
      return {
        width: centerbox.clientWidth || 0,
        height: centerbox.clientHeight || 0,
      };
    },
  },
  watch: {
    // greenhouseId 变化时联动刷新在线监测数据和预警数据
    selectedGreenhouseId(newVal) {
      if (newVal) {
        this.getdata();
        this.getwarningdata();
        this.fetchMonitorUrl();
      } else {
        this.monitorUrl = "";
      }
      this.closedialog();
    },
  },
  mounted() {
    // 动态获取Header的实际高度（.headermain的高度是78px）
    this.$nextTick(() => {
      const headerElement = document.querySelector(".headermain");
      if (headerElement) {
        this.headerHeight = headerElement.offsetHeight || 78;
      }
    });

    // 监听全屏状态变化
    this.checkFullscreen();
    document.addEventListener('fullscreenchange', this.handleFullscreenChange);
    document.addEventListener('webkitfullscreenchange', this.handleFullscreenChange);
    document.addEventListener('mozfullscreenchange', this.handleFullscreenChange);
    document.addEventListener('MSFullscreenChange', this.handleFullscreenChange);

    // 加载大棚下拉
    this.fetchGreenhouseOptions();

    // 检查是否有预览配置
    const previewConfigStr = sessionStorage.getItem(
      "devicePositionPreviewConfig"
    );
    if (previewConfigStr) {
      try {
        this.previewConfig = JSON.parse(previewConfigStr);
        this.activeDeviceId = null;
        // 预览模式默认选中大棚
        if (this.previewConfig && this.previewConfig.greenhouseId) {
          this.selectedGreenhouseId = this.previewConfig.greenhouseId;
        }
        // 清除 sessionStorage 中的配置
        sessionStorage.removeItem("devicePositionPreviewConfig");
      } catch (error) {
        console.error("解析预览配置失败:", error);
      }
    }

    // 如果不是预览模式，正常加载数据
    // 先获取在线状态数据，再获取设备列表
    this.getonlinedata().then(() => {
      this.getdata();
      this.getwarningdata();
    });
    // 组件挂载后启动定时器，每30秒执行一次
    // this.timer2 = setInterval(() => {
    //     this.getwarningdata()
    // }, 30000);
  },
  beforeDestroy() {
    // 组件销毁前清除定时器
    if (this.timer2) {
      clearInterval(this.timer2);
    }
    // 移除全屏监听
    document.removeEventListener('fullscreenchange', this.handleFullscreenChange);
    document.removeEventListener('webkitfullscreenchange', this.handleFullscreenChange);
    document.removeEventListener('mozfullscreenchange', this.handleFullscreenChange);
    document.removeEventListener('MSFullscreenChange', this.handleFullscreenChange);
  },
  methods: {
    // 检查全屏状态
    checkFullscreen() {
      this.isFullscreen = !!(document.fullscreenElement || 
        document.webkitFullscreenElement || 
        document.mozFullScreenElement || 
        document.msFullscreenElement);
    },
    // 处理全屏状态变化
    handleFullscreenChange() {
      this.checkFullscreen();
      // 全屏状态变化时，强制重新计算设备位置
      this.$forceUpdate();
    },
    isLongDeviceName(name) {
      return (name || "").length > 5;
    },
    isDeviceActive(deviceId) {
      if (deviceId == null || this.activeDeviceId == null) return false;
      return String(this.activeDeviceId) === String(deviceId);
    },
    isDeviceOffline(device) {
      return !device.onlineStatus;
    },
    handlePreviewDeviceClick(device) {
      if (!device) return;
      this.activeDeviceId = device.id != null ? device.id : null;
      this.showDeviceDetail(device);
    },
    async showDeviceDetail(device) {
      const normalizedDevice = this.normalizeDevice(device);
      console.log("normalizedDevice", normalizedDevice);
      console.log("device", device);
      const deviceName = normalizedDevice.deviceName;
      if (!deviceName) return;
      const currentRequestId = ++this.detailRequestId;
      this.detailLoading = true;
      this.valueedlist = this.getValueListForDevice(normalizedDevice);
      this.detailvalue = this.buildInitialDetailValue(
        normalizedDevice,
        this.valueedlist
      );
      this.showdetailtitle = deviceName;
      // 保存当前设备信息，用于跳转到详情页
      this.currentDevice = {
        id: device.id,
        name: deviceName,
        deviceName: deviceName,
        classify: normalizedDevice.classify,
      };
      this.setDialogPosition(normalizedDevice);
      try {
        const detailRes = await axios.get(
          `${baseUrl}/api/data-center/monitoring-data/device-last-data?deviceId=${device.id}`
        );
        console.log("detailRes", detailRes);
        if (currentRequestId !== this.detailRequestId) {
          return;
        }
        if (detailRes.data) {
          this.detailvalue = detailRes.data;
          this.detailvalue["online"] = device.onlineStatus;
        }
      } catch (error) {
        if (currentRequestId === this.detailRequestId) {
          console.error("获取设备详情失败:", error);
        }
      } finally {
        if (currentRequestId === this.detailRequestId) {
          this.detailLoading = false;
        }
      }
    },
    setDialogPosition(device) {
      this.$nextTick(() => {
        const container = this.$refs.centerbox;
        if (!container) return;
        const dialog = this.$refs.detailDialog;
        const containerRect =
          (container.getBoundingClientRect &&
            container.getBoundingClientRect()) ||
          null;
        const containerWidth = containerRect
          ? containerRect.width
          : container.clientWidth || 0;
        const containerHeight = containerRect
          ? containerRect.height
          : container.clientHeight || 0;
        if (!containerWidth || !containerHeight) return;
        const dialogRect =
          (dialog &&
            dialog.getBoundingClientRect &&
            dialog.getBoundingClientRect()) ||
          null;
        const dialogWidth =
          (dialogRect && dialogRect.width) ||
          (dialog && dialog.offsetWidth) ||
          450;
        const dialogHeight =
          (dialogRect && dialogRect.height) ||
          (dialog && dialog.offsetHeight) ||
          200;

        const { x, y } = this.getDeviceCoordinates(device);
        const anchorX = x * containerWidth;
        const anchorY = y * containerHeight;

        const spacing = 60; // keep dialog farther from device
        const padding = 12;

        const clampLeft = (value) => {
          const maxLeft = containerWidth - dialogWidth - padding;
          if (maxLeft <= padding) {
            return Math.max(padding, (containerWidth - dialogWidth) / 2);
          }
          return Math.max(padding, Math.min(value, maxLeft));
        };
        const clampTop = (value) => {
          const maxTop = containerHeight - dialogHeight - padding;
          if (maxTop <= padding) {
            return Math.max(padding, (containerHeight - dialogHeight) / 2);
          }
          return Math.max(padding, Math.min(value, maxTop));
        };

        const candidates = [];
        const spaceTop = anchorY - padding;
        const spaceBottom = containerHeight - anchorY - padding;
        const spaceLeft = anchorX - padding;
        const spaceRight = containerWidth - anchorX - padding;

        if (spaceTop >= dialogHeight + spacing) {
          candidates.push({
            placement: "top",
            left: anchorX - dialogWidth / 2,
            top: anchorY - spacing - dialogHeight,
          });
        }
        if (spaceBottom >= dialogHeight + spacing) {
          candidates.push({
            placement: "bottom",
            left: anchorX - dialogWidth / 2,
            top: anchorY + spacing,
          });
        }
        if (spaceRight >= dialogWidth + spacing) {
          candidates.push({
            placement: "right",
            left: anchorX + spacing,
            top: anchorY - dialogHeight / 2,
          });
        }
        if (spaceLeft >= dialogWidth + spacing) {
          candidates.push({
            placement: "left",
            left: anchorX - spacing - dialogWidth,
            top: anchorY - dialogHeight / 2,
          });
        }

        const fallbackOrder = [
          { placement: "bottom", score: spaceBottom },
          { placement: "top", score: spaceTop },
          { placement: "right", score: spaceRight },
          { placement: "left", score: spaceLeft },
        ].sort((a, b) => b.score - a.score);

        let chosen = candidates.length ? candidates[0] : null;
        if (!chosen) {
          for (const option of fallbackOrder) {
            if (option.score <= 0) continue;
            switch (option.placement) {
              case "bottom":
                chosen = {
                  placement: "bottom",
                  left: anchorX - dialogWidth / 2,
                  top: anchorY + spacing,
                };
                break;
              case "top":
                chosen = {
                  placement: "top",
                  left: anchorX - dialogWidth / 2,
                  top: anchorY - spacing - dialogHeight,
                };
                break;
              case "right":
                chosen = {
                  placement: "right",
                  left: anchorX + spacing,
                  top: anchorY - dialogHeight / 2,
                };
                break;
              case "left":
                chosen = {
                  placement: "left",
                  left: anchorX - spacing - dialogWidth,
                  top: anchorY - dialogHeight / 2,
                };
                break;
              default:
                break;
            }
            if (chosen) break;
          }
        }

        if (!chosen) {
          chosen = {
            placement: "top",
            left: anchorX - dialogWidth / 2,
            top: anchorY - spacing - dialogHeight,
          };
        }

        const left = clampLeft(chosen.left);
        const top = clampTop(chosen.top);

        this.dialogstyle.left = `${left}px`;
        this.dialogstyle.top = `${top}px`;
        this.dialogstyle.transform = "";
        this.dialogstyle.icon = require("../assets/img/tip/tipbg.png");

        const placement = chosen.placement;
        let attachX = left + dialogWidth / 2;
        let attachY = top;
        if (placement === "top") {
          attachY = top + dialogHeight;
        } else if (placement === "bottom") {
          attachY = top;
        } else if (placement === "left") {
          attachX = left + dialogWidth;
          attachY = top + dialogHeight / 2;
        } else if (placement === "right") {
          attachX = left;
          attachY = top + dialogHeight / 2;
        }
        if (placement === "top" || placement === "bottom") {
          attachX = clampLeft(left) + dialogWidth / 2;
        }

        const buildPolylinePoints = () => {
          if (placement === "left" || placement === "right") {
            const midpointX = (anchorX + attachX) / 2;
            return [
              `${anchorX},${anchorY}`,
              `${midpointX},${anchorY}`,
              `${midpointX},${attachY}`,
              `${attachX},${attachY}`,
            ].join(" ");
          }
          const midpointY = (anchorY + attachY) / 2;
          return [
            `${anchorX},${anchorY}`,
            `${anchorX},${midpointY}`,
            `${attachX},${midpointY}`,
            `${attachX},${attachY}`,
          ].join(" ");
        };

        this.dialogline = {
          visible: true,
          points: buildPolylinePoints(),
          startPoint: { x: anchorX, y: anchorY },
          endPoint: { x: attachX, y: attachY },
        };
      });
    },
    getDeviceCoordinates(device) {
      if (!device) {
        return { x: 0.5, y: 0.5 };
      }
      let x = Number(device.x);
      let y = Number(device.y);
      if (Number.isNaN(x)) {
        x = 0.5;
      }
      if (Number.isNaN(y)) {
        y = 0.5;
      }
      if (x > 1 || y > 1) {
        x = x / 100;
        y = y / 100;
      }
      return {
        x: Math.max(0, Math.min(1, x)),
        y: Math.max(0, Math.min(1, y)),
      };
    },
    // 加载大棚选项（与管理页一致）
    async fetchGreenhouseOptions() {
      try {
        const formData = new FormData();
        formData.append("enableStatus", 1);
        const greenhouseRes = await axios.post(
          baseUrl + "/api/basic/greenhouse/selection",
          formData
        );
        this.greenhouseOptions = (greenhouseRes.data || []).map((item) => ({
          label: item.serialNumber,
          value: item.id,
        }));
        // 非预览模式下默认选中第一个大棚并加载背景与设备
        if (
          !this.isPreviewMode &&
          !this.selectedGreenhouseId &&
          this.greenhouseOptions.length
        ) {
          this.selectedGreenhouseId = this.greenhouseOptions[0].value;
          this.loadGreenhouseData();
        }
      } catch (e) {
        console.error("加载大棚选项失败:", e);
      }
    },
    async fetchMonitorUrl() {
      if (!this.selectedGreenhouseId) {
        this.monitorUrl = "";
        return;
      }
      try {
        const params = {
          page: 1,
          pageSize: 10,
          tenantId: "",
          greenhouseId: this.selectedGreenhouseId,
        };
        const res = await axios.post(
          `${baseUrl}/api/monitor/list-page`,
          params
        );
        const list = (res && res.data && res.data.list) || [];
        console.log("监控列表", list);

        this.monitorUrl = list.length ? list[0].monitorUrl || "" : "";
      } catch (error) {
        console.error("加载实时监控失败:", error);
        this.monitorUrl = "";
      }
    },
    handleGreenhouseChange(val) {
      // 这里仅记录选择，如需联动筛选可在此触发后续逻辑
      this.selectedGreenhouseId = val || "";
      this.activeDeviceId = null;
      if (!this.isPreviewMode && this.selectedGreenhouseId) {
        this.loadGreenhouseData();
      }
    },
    // 关闭预览：通知父级编辑器
    closePreview() {
      try {
        window.parent &&
          window.parent.postMessage({ type: "DEVICE_PREVIEW_CLOSE" }, "*");
      } catch (e) {
        console.error("发送关闭预览消息失败:", e);
      }
      this.activeDeviceId = null;
    },
    // 非预览模式：加载默认背景与设备列表
    async loadGreenhouseData() {
      if (!this.selectedGreenhouseId) return;
      try {
        // 背景图
        const bgRes = await axios.post(
          `${baseUrl}/api/basic/greenhouse-bg/default-bg/${this.selectedGreenhouseId}`
        );
        this.defaultBg = bgRes && bgRes.data ? bgRes.data : null;
      } catch (e) {
        console.error("加载默认背景失败:", e);
        this.defaultBg = null;
      }
      try {
        // 设备列表（包含bgXY与greenhouseId）
        const listRes = await axios.post(
          `${baseUrl}/api/device/device-info/list-all`,
          {
            deviceType: "MONITORING_DEVICE",
            greenhouseId: this.selectedGreenhouseId,
          }
        );
        this.allDevices = Array.isArray(listRes && listRes.data)
          ? listRes.data
          : [];
      } catch (e) {
        console.error("加载设备列表失败:", e);
        this.allDevices = [];
      }
    },
    // 解析后台 bgXY 字符串为 0-1 范围坐标
    parseBgXY(bgXY) {
      if (!bgXY || typeof bgXY !== "string") return { x: null, y: null };
      const parts = bgXY.split(",").map((v) => Number(v));
      if (parts.length !== 2 || parts.some((n) => isNaN(n)))
        return { x: null, y: null };
      let [x, y] = parts;
      // 兼容 0-100 的百分比与 0-1 的小数
      if (x > 1 || y > 1) {
        x = x / 100;
        y = y / 100;
      }
      // 夹紧范围
      x = Math.max(0, Math.min(1, x));
      y = Math.max(0, Math.min(1, y));
      return { x, y };
    },
    // 获取设备图片
    getDeviceImage(imageName) {
      if (!imageName) return "";
      try {
        return require(`../assets/img/equipment/${imageName}`);
      } catch (error) {
        console.error("加载设备图片失败:", error);
        return "";
      }
    },
    getPreviewDeviceImage(device) {
      if (!device) return "";
      const baseImageName = device.image || "";
      const finalImageName = this.getImageNameWithActiveState(
        baseImageName,
        device.id
      );
      return this.getDeviceImage(finalImageName);
    },
    // 非预览模式：根据设备id加载图片：@/assets/img/equipment/${设备id}
    getNonPreviewDeviceImage(device) {
      if (!device || !device.classify) return "";
      const isOffline = this.isDeviceOffline(device);
      const prefix = isOffline ? "l" : "e";
      const baseImageName = `${prefix}${device.classify}.png`;
      const finalImageName = this.getImageNameWithActiveState(
        baseImageName,
        device.id
      );
      return this.getDeviceImage(finalImageName);
    },
    getImageNameWithActiveState(baseImageName, deviceId) {
      if (!baseImageName) return "";
      const normalized = baseImageName.replace(/^a_/, "");
      return this.isDeviceActive(deviceId) ? `a_${normalized}` : normalized;
    },
    // 预览模式下的设备样式（相对于centerbox定位）
    getPreviewDeviceStyle(device) {
      if (!this.isPreviewMode || !device) {
        return {};
      }
      // 使用与非预览模式相同的补偿逻辑
      return this.getNonPreviewDeviceStyle(device);
    },
    // 非预览模式下的设备样式（动态补偿位置）
    getNonPreviewDeviceStyle(device) {
      if (!device) {
        return {
          position: "absolute",
          left: "50%",
          top: "50%",
          transform: "translate(-50%, -50%)",
          cursor: "pointer",
        };
      }
      
      // 基础位置（百分比）
      let leftPercent = device.x * 100;
      let topPercent = device.y * 100;
      
      // 根据视口宽高比动态调整垂直位置
      // 这是关键：补偿背景图在不同宽高比下的显示差异
      const viewportWidth = window.innerWidth;
      const viewportHeight = window.innerHeight;
      const designRatio = this.designWidth / this.designHeight;
      const viewportRatio = viewportWidth / viewportHeight;
      
      // 如果视口比设计稿更宽（如21:9显示器），背景图会被垂直裁剪
      // 需要向上调整设备位置
      if (viewportRatio > designRatio) {
        // 计算背景图实际显示的高度比例
        const actualHeightRatio = (viewportWidth / designRatio) / viewportHeight;
        // 调整垂直位置：背景图被拉伸了，设备需要相应调整
        const offset = (actualHeightRatio - 1) / 2;
        topPercent = topPercent * actualHeightRatio - offset * 100;
      }
      // 如果视口比设计稿更高（如4:3显示器），背景图会被水平裁剪
      // 需要向左调整设备位置
      else if (viewportRatio < designRatio) {
        const actualWidthRatio = (viewportHeight * designRatio) / viewportWidth;
        const offset = (actualWidthRatio - 1) / 2;
        leftPercent = leftPercent * actualWidthRatio - offset * 100;
      }
      
      return {
        position: "absolute",
        left: `${leftPercent}%`,
        top: `${topPercent}%`,
        transform: "translate(-50%, -50%)",
        cursor: "pointer",
      };
    },
    getonlinedata() {
      return getonlinelist().then((res) => {
        console.log("在线状态", res);
        res.data.forEach((item) => {
          this.onlinelist[item.deviceName] = item.online;
        });
      });
    },
    getwarningdata() {
      let params = `page=1&size=10`;
      if (this.selectedGreenhouseId) {
        params += `&greenhouseId=${this.selectedGreenhouseId}`;
      }
      getwarlist(params).then((res) => {
        console.log("预警列表", res);
        this.tabledata = res.data.records;
        const newdata = res.data.records[0];
        if (newdata && newdata.isRead == 0) {
          this.toread(newdata.content);
          this.settimer(Number(newdata.time));
        }
      });
    },
    settimer(seconds) {
      // 清除已有的计时器
      if (this.timer) {
        clearInterval(this.timer);
        this.timer = null;
      }

      // 倒计时剩余秒数
      this.countdown = seconds;

      // 创建新的计时器
      this.timer = setInterval(() => {
        this.countdown--;
        // 倒计时结束
        if (this.countdown <= 0) {
          clearInterval(this.timer);
          this.timer = null;

          // 执行倒计时结束后的回调（可选）
          // if (typeof this.onTimerEnd === 'function') {
          //     this.onTimerEnd();
          // }
        }
      }, 1000);
    },

    toread(text) {
      let xhr = new XMLHttpRequest();
      xhr.open("POST", baseUrl + "/audioapi/tts", true);
      const formData = new FormData();
      formData.append("text", text);
      formData.append("voice", "zh-CN-YunyangNeural");
      formData.append("speed", -10);
      // const url = window.URL.createObjectURL(fileOfBlob)
      // this.src = url
      xhr.send(formData);
      const that = this;
      xhr.onreadystatechange = () => {
        if (xhr.readyState === 4 && xhr.status === 200) {
          const res = JSON.parse(xhr.responseText);
          console.log(res);
          this.audiourl = res.audio;
          // 创建新的Audio实例
          this.audio = new Audio(res.audio);

          // 监听元数据加载完成事件
          this.audio.addEventListener("loadedmetadata", () => {
            // 获取音频时长（秒）
            console.log(this.audio.duration);
            this.audiolang = this.audio.duration;
          });
          setTimeout(() => {
            document.getElementById("play").click();
          }, 2000);
        }
      };
    },
    readans() {
      const audioelement = document.getElementById("ansaudio");
      if (audioelement) {
        // 检查音频是否正在播放
        const isPlaying = !audioelement.paused;

        if (isPlaying) {
          this.audioing = false;
          audioelement.pause();
          clearTimeout(this.timeoutId);
        } else {
          this.audioing = true;
          audioelement.play();
          this.timeoutId = setTimeout(() => {
            audioelement.pause();
            audioelement.play();

            this.setstatus();
          }, this.audiolang * 1000 + 1000);
        }
      }
    },
    // 判断设备是否在线
    isDeviceOnline(deviceName) {
      return this.onlinelist[deviceName] === true;
    },

    setstatus() {
      setreadstatus(this.tabledata[0].id).then((res) => {
        console.log("设置已读", res);
      });
    },
    godetail(e) {
      console.log(e);
      // 构建查询参数
      const params = {
        t: "table",
        n: e, // 设备名称
      };
      // 如果有当前设备信息，传递设备ID和大棚ID
      if (this.currentDevice && this.currentDevice.id) {
        params.deviceId = this.currentDevice.id;
      }
      if (this.selectedGreenhouseId) {
        params.greenhouseId = this.selectedGreenhouseId;
      }
      // 构建查询字符串
      const queryString = Object.keys(params)
        .map((key) => `${key}=${encodeURIComponent(params[key])}`)
        .join("&");
      router.push(`/data?${queryString}`);
    },
    gowarn() {
      router.push("/data?t=warn");
    },
    gopage(e) {
      router.push(e);
    },
    ptypeclick(e) {
      this.ptype = e;
      this.getdata();
    },
    closedialog() {
      this.detailRequestId++;
      this.showdetailtitle = "";
      this.currentDevice = null;
      this.valueedlist = [];
      this.detailvalue = {};
      this.activeDeviceId = null;
      this.detailLoading = false;
      this.dialogline = {
        visible: false,
        points: "",
        startPoint: { x: 0, y: 0 },
        endPoint: { x: 0, y: 0 },
      };
    },
    getdata() {
      const query = [`type=${this.ptype}`];
      if (this.selectedGreenhouseId) {
        query.push(`greenhouseId=${this.selectedGreenhouseId}`);
      }
      getsbcount(query.join("&")).then((res) => {
        console.log("设备统计", res);
        this.sbcount = res.data;
      });
    },
    govideopage() {
      router.push("/camera");
    },
    sbclick(name, item) {
      console.log(name, item);
      const parseValue = (primary, secondary) => {
        if (item && item[primary]) {
          return this.parsePercentToDecimal(item[primary]);
        }
        if (item && item[secondary]) {
          const val = this.parsePercentToDecimal(item[secondary]);
          return val != null ? 1 - val : null;
        }
        return null;
      };
      const device = {
        name,
        deviceName: name,
        x: parseValue("left", "right"),
        y: parseValue("top", "bottom"),
      };
      this.showDeviceDetail(device);
    },
    parsePercentToDecimal(value) {
      if (value == null) return null;
      const num = parseFloat(String(value).replace("%", ""));
      if (Number.isNaN(num)) return null;
      const normalized = num > 1 ? num / 100 : num;
      return Math.max(0, Math.min(1, normalized));
    },
    normalizeDevice(device) {
      if (!device) {
        return {
          deviceName: "",
          name: "",
          x: 0.5,
          y: 0.5,
          classify: "",
        };
      }
      const deviceName = device.deviceName || device.name || "";
      return {
        ...device,
        deviceName,
        name: device.name || deviceName,
        classify:
          device.classify ||
          device.deviceType ||
          device.type ||
          device.category ||
          "",
      };
    },
    getValueListForDevice(device) {
      if (!device) return [];
      const typeKey = device.classify || "";
      console.log("this.valuekeylist", this.valuekeylist, typeKey);

      return this.valuekeylist[typeKey] || [];
    },
    buildInitialDetailValue(device, valueList) {
      const detail = {
        deviceName: device.deviceName,
        name: device.name,
        online: this.isDeviceOnline(device.deviceName),
        time:
          device.time ||
          device.updateTime ||
          device.lastUpdateTime ||
          device.reportTime ||
          "",
      };
      (valueList || []).forEach(({ value }) => {
        detail[value] = this.extractDeviceFieldValue(device, value);
      });
      return detail;
    },
    extractDeviceFieldValue(device, key) {
      if (!device || !key) return "--";
      const candidateSources = [
        device[key],
        device[key.toLowerCase ? key.toLowerCase() : key],
        device.latestData ? device.latestData[key] : undefined,
      ];
      const resolved = candidateSources.find(
        (val) => val !== undefined && val !== null && val !== ""
      );
      return resolved !== undefined ? resolved : "--";
    },
  },
};
</script>

<style scoped lang="less">
@font-face {
  font-family: "title";
  src: url("../assets/font/title.ttf");
}

.main {
  width: 100%;
  height: 100%;
  position: relative;
  // 默认背景色，预览模式下会被内联样式覆盖
  background-color: #0b1946;
  overflow: hidden;

  .greenhouse-select {
    position: absolute;
    top: 48px;
    left: 10px;
    z-index: 3001;
  }

  .preview-mask {
    position: fixed;
    left: 0;
    top: 0;
    width: 100vw;
    height: 100vh;
    background: rgba(0, 0, 0, 0);
    z-index: 300;
  }
  .preview-close {
    position: fixed;
    left: 50%;
    bottom: 98px;
    transform: translateX(-50%);
    z-index: 3001;
    background: #2680dd;
    color: #fff;
    padding: 10px 20px;
    border-radius: 4px;
    cursor: pointer;
    font-size: 40px;
    user-select: none;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.2);
  }

  .topbox {
    width: 100%;
    height: 78px;
    display: flex;
    justify-content: center;
    background-image: url("../assets/img/home/topbg.png");
    background-size: 100% 100%;

    .leftbtnbox {
      width: 600px;
      height: 60px;
      background-image: url("../assets/img/home/leftbtnbg.png");
      background-size: 100% 100%;
      margin-top: 10px;
      justify-content: flex-end;
      padding: 5px;
      padding-right: 40px;

      .btnitem {
        background-image: url("../assets/img/home/leftbtn.png");
        background-size: 100% 100%;
      }
    }

    .title {
      width: 23%;
      height: 60px;
      font-size: 28px;
      color: #fff;
      display: flex;
      justify-content: center;
      align-items: center;

      img {
        width: 30px;
      }
    }

    .rightbtnbox {
      width: 600px;
      height: 60px;
      background-image: url("../assets/img/home/rightbtnbg.png");
      background-size: 100% 100%;
      margin-top: 10px;
      justify-content: flex-start;
      padding: 5px;
      padding-left: 15px;

      .btnitem:hover {
        .menubox {
          display: block;
        }
      }

      .btnitem {
        background-image: url("../assets/img/home/rightbtn.png");
        background-size: 100% 100%;
        cursor: pointer;
        position: relative;

        .menubox:hover {
          display: block;
        }

        .menubox {
          position: absolute;
          left: 0px;
          width: 150px;
          top: 40px;
          background-color: #030f29;
          border-bottom: 0;
          color: #fff;
          display: none;
          z-index: 99;
          box-shadow: inset 0px -5px 11px 0px #0057c1;
          border-radius: 0px 0px 0px 0px;
          border: 1px solid;
          border-image: linear-gradient(
              180deg,
              rgba(99, 169, 255, 0),
              rgba(99, 169, 255, 1)
            )
            1 1;

          .menubtn {
            padding: 15px;
            text-align: center;

            font-size: 16px;
            font-weight: bold;
          }

          .menubtn:hover {
            background-color: #0389f8;
            color: #fff;
          }
        }
      }

      .btnitemed {
        background-image: url("../assets/img/home/rightbtned.png");
        background-size: 100% 100%;
      }
    }

    .leftbtnbox,
    .rightbtnbox {
      display: flex;

      .btnitem {
        font-size: 20px;
        color: #fff;
        width: 170px;
        height: 40px;
        margin: 10px;
        display: flex;
        align-items: center;
        justify-content: center;
      }
    }
  }

  .centerbox {
    width: 100%;
    height: calc(100% - 400px);
    display: flex;
    flex-wrap: wrap;
    position: relative;

    // 预览设备样式
    .preview-device-item {
      position: absolute;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      z-index: 20;

      .device-label {
        position: absolute;
        left: 50%;
        bottom: calc(100% - 20px);
        transform: translate(-50%, 0);
        margin: 0;
        max-width: 220px;
        padding: 8px 10px;
        font-family: YouSheBiaoTiHei, YouSheBiaoTiHei;
        font-weight: 400;
        font-size: 20px;
        color: #ffffff;
        background: linear-gradient(
            90deg,
            rgba(22, 255, 204, 0) 0%,
            rgba(22, 255, 204, 0.3) 50%,
            rgba(22, 255, 204, 0) 100%
          ),
          rgba(15, 92, 75, 0.6);
        box-shadow: inset 0px 0px 12px 0px #59fff1;
        letter-spacing: 1px;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        user-select: none;
        display: inline-flex;
        align-items: center;
        justify-content: center;
        opacity: 0;
        visibility: hidden;
        pointer-events: none;
        max-height: 200px;
        transition: opacity 0.2s ease;
      }
      &:hover .device-label {
        opacity: 1;
        visibility: visible;
      }
      .device-label.long-name {
        min-width: 140px;
        white-space: normal;
        word-break: break-all;
        text-align: center;
        line-height: 1.2;
        max-width: 140px;
      }
      .device-label.is-offline {
        background: linear-gradient(
            90deg,
            rgba(255, 84, 84, 0) 0%,
            rgba(255, 120, 120, 0.5) 50%,
            rgba(255, 84, 84, 0) 100%
          ),
          rgba(102, 0, 0, 0.6);
        box-shadow: inset 0px 0px 11px 0px #ff824c;
      }

      .device-icon {
        width: clamp(40px, 5vw, 80px);
        height: clamp(40px, 5vw, 80px);
        object-fit: contain;
        filter: drop-shadow(0 2px 4px rgba(0, 0, 0, 0.3));
      }
      .device-dot {
        width: clamp(10px, 1.2vw, 18px);
        height: clamp(10px, 1.2vw, 18px);
        border-radius: 50%;
        background: #00e0ff;
        box-shadow: 0 0 10px rgba(0, 224, 255, 0.9),
          0 0 20px rgba(0, 224, 255, 0.5);
      }
    }
    .top-area,
    .middle-area {
      width: 100%;
      height: calc(50% - 10px);
      display: flex;
      .left-function-area {
        width: 120px;
        height: 100%;
        .function-room {
          width: 100%;
          height: 50%;
          display: flex;
          align-items: center;
          justify-content: center;
          border: 2px dashed #0377ee;
          background-color: #002c59;
          font-size: 20px;
          color: #fff;
        }
      }
      .area {
        width: 30%;
        border: 2px dashed #58a7f6;
        background-color: #002c59;

        background-image: url("../assets/img/home/b1.png");
        background-size: 100% 100%;
        justify-content: center;
        display: flex;
        flex-wrap: wrap;
        align-items: center;
        h3 {
          position: absolute;
          font-size: 78px;
          color: #ffffff20;
        }
        .device {
          width: 50%;
          height: 50%;
          display: flex;
          justify-content: center;
          align-items: center;
          flex-wrap: wrap;
          align-content: center;
          cursor: pointer;
          .device-type {
            width: 130px;
            font-size: 16px;
            text-align: center;
            background-image: url("../assets/img/home/newitembg.png");
            background-size: 100% 100%;
            padding: 5px;
            color: #fff;
          }
          .btypeunline {
            background-image: url("../assets/img/home/newitemunbg.png");
          }
          .point {
            width: 100%;
            text-align: center;
            img {
              width: 22px;
            }
          }
        }
      }
      .right-top-area {
        width: calc(40% - 120px);
        height: 100%;
        display: flex;
        background-image: url("../assets/img/home/b1.png");
        background-color: #002c59;
        background-size: 100% 100%;
        border: 2px dashed #58a7f6;

        .rowitem {
          width: 16.6%;
          height: 100%;
          .row-area {
            width: 70%;
            height: 100%;
            margin: 0 auto;
            display: flex;
            flex-wrap: wrap;
            align-items: center;
            background-color: #00f6ff20;
            overflow: visible;
            .device {
              width: 100%;
              display: flex;
              justify-content: center;
              align-items: center;
              flex-wrap: wrap;
              align-content: center;
              position: relative;
              cursor: pointer;
              .device-type {
                width: calc(100% + 20px);
                position: absolute;
                left: -10px;
                font-size: 14px;
                text-align: center;
                background-image: url("../assets/img/home/newitembg.png");
                background-size: 100% 100%;
                padding: 5px;
                color: #fff;
              }
              .btypeunline {
                background-image: url("../assets/img/home/newitemunbg.png");
              }
              .point {
                position: absolute;
                left: 0px;
                top: 20px;
                width: 100%;
                text-align: center;
                img {
                  width: 22px;
                }
              }
            }
          }
        }
      }
    }
    .tipbox {
      width: 450px;
      height: 200px;
      position: absolute;
      background-size: 100% 100%;
      z-index: 4000;

      .tiptop {
        padding: 10px;
        font-size: 22px;
        font-family: "title";
        color: #fff;
        position: relative;

        .closebtn {
          font-family: "Courier New", Courier, monospace;
          position: absolute;
          right: 0px;
          top: -2px;
          width: 30px;
          height: 30px;
          border-radius: 50%;
          display: flex;
          font-size: 32px;
          justify-content: center;
          align-items: center;
          background-color: #012b66;
          cursor: pointer;
        }
      }

      .tipcontent {
        height: calc(100% - 66px);
        display: flex;
        flex-wrap: wrap;
        color: #fff;
        position: relative;
        .tiploading {
          width: 100%;
          display: flex;
          align-items: center;
          justify-content: center;
          font-size: 18px;
          color: #88a0c6;
          gap: 8px;
          .el-icon-loading {
            font-size: 22px;
          }
        }

        .tipvalueitem {
          font-size: 16px;
          margin: 0 10px;

          .value {
            color: #04ff9f;
          }
        }
      }

      .uptime {
        position: absolute;
        left: 10px;
        bottom: 10px;
        font-size: 12px;
        color: #b6bcc7;
        width: calc(100% - 10px);
        display: flex;
        justify-content: space-between;
        align-items: center;

        .more {
          padding-right: 15px;
          cursor: pointer;
        }
      }
    }
    .tipline {
      position: absolute;
      left: 0;
      top: 0;
      width: 100%;
      height: 100%;
      pointer-events: none;
      z-index: 3500;
    }
    .tipline polyline {
      fill: none;
      stroke: #43c4ff;
      stroke-width: 3;
      stroke-linejoin: round;
      stroke-linecap: round;
      filter: drop-shadow(0 0 4px rgba(67, 196, 255, 0.8));
    }
    .tipline circle {
      fill: #43c4ff;
      stroke: #b6f4ff;
      stroke-width: 1;
    }
    .tipline-start {
      fill: #0b1946;
      stroke-width: 3;
    }
    .middle-area {
      .left-function-area {
        width: 120px;
        height: 100%;
        .function-room {
          width: 100%;
          height: 25%;
          display: flex;
          align-items: center;
          justify-content: center;
          border: 2px dashed #0377ee;
          background-color: #002c59;
          font-size: 20px;
          color: #fff;
        }
      }
      .b3-area {
        width: calc(40% - 120px);
        height: 100%;
        display: flex;
        flex-wrap: wrap;
        background-color: #002c59;
        background-size: 100% 100%;
        border: 2px dashed #58a7f6;
        .b3top {
          width: 100%;
          height: 55%;
          display: flex;
          border: 1px dashed #0377ee;
          .b3top1 {
            width: 70%;
            background-image: url("../assets/img/home/b3.png");
            background-size: 100% 100%;
            position: relative;
            justify-content: center;
            display: flex;
            flex-wrap: wrap;
            align-items: center;
            h3 {
              position: absolute;
              font-size: 38px;
              color: #ffffff20;
            }
            .device {
              width: 50%;
              height: 50%;
              display: flex;
              justify-content: center;
              align-items: center;
              flex-wrap: wrap;
              align-content: center;
              cursor: pointer;
              .device-type {
                width: 150px;
                font-size: 14px;
                text-align: center;
                background-image: url("../assets/img/home/newitembg.png");
                background-size: 100% 100%;
                padding: 5px;
                color: #fff;
              }
              .btypeunline {
                background-image: url("../assets/img/home/newitemunbg.png");
              }
              .point {
                width: 100%;
                text-align: center;
                img {
                  width: 22px;
                }
              }
            }
          }
          .b3top2 {
            width: 30%;
            height: 100%;
            .top2item1 {
              width: 100%;
              height: 50%;
              display: flex;
              align-items: center;
              justify-content: center;
              border: 1px dashed #0377ee;
              background-color: #002c59;
              font-size: 20px;
              color: #e4e4e4;
            }
          }
        }
        .b3center {
          width: 100%;
          height: 15%;
          display: flex;
          justify-content: space-between;
          .citem1 {
            width: 40%;
            height: 100%;
            display: flex;
            align-items: center;
            justify-content: center;
            border: 1px dashed #0377ee;
            background-color: #002c59;
            font-size: 20px;
            color: #e4e4e4;
          }
        }
        .b3btm {
          width: 100%;
          height: 30%;
          display: flex;
          border: 1px dashed #0377ee;
          .b3btm1 {
            width: 80%;
            position: relative;
            justify-content: center;
            display: flex;
            flex-wrap: wrap;
            align-items: center;
            h3 {
              position: absolute;
              font-size: 38px;
              color: #ffffff20;
            }
          }
          .b3btm2 {
            width: 20%;
            height: 100%;
            .btm2item1 {
              width: 100%;
              height: 50%;
              display: flex;
              align-items: center;
              justify-content: center;
              border: 1px dashed #0377ee;
              background-color: #002c59;
              font-size: 20px;
              color: #e4e4e4;
            }
          }
        }
      }
    }
  }

  .bottombox {
    position: absolute;
    bottom: 8px;
    left: 8px;
    z-index:22;
    width: calc(100% - 15px);
    display: flex;
    height: 36vh;
    background-color: #0b1946;
    justify-content: space-around;

    .blbox,
    .bcbox,
    .brbox {
      margin: 4px;

      .title {
        width: 100%;
        height: 40px;
        background-image: url("../assets/img/home/titlebg.png");
        background-size: 100% 100%;
        display: flex;
        align-items: center;
        justify-content: space-between;
        font-size: 24px;
        color: #fff;
        padding-left: 40px;
        font-family: "title", "Source Han Sans CN", Avenir, Helvetica, Arial,
          sans-serif !important;

        img {
          width: 25px;
          margin-right: 10px;
          cursor: pointer;
        }

        .time {
          font-size: 12px;
          color: #fff;
          font-family: "Courier New", Courier, monospace;
        }

        .btns {
          display: flex;
          font-size: 14px;
          color: #fff;
          margin-right: 5px;
          font-family: "Courier New", Courier, monospace;

          .btnitem {
            padding: 5px 10px;
            background-color: #021523;
            cursor: pointer;
          }

          .btned {
            background-color: #2680dd;
          }
        }
      }

      .contentbox {
        width: 100%;
        height: calc(100% - 40px);
        background-size: 100% 100%;
        overflow-y: auto;
        display: flex;
        flex-wrap: wrap;
        padding: 10px;

        .zxitem {
          width: calc(50% - 10px);
          height: 50%;
          margin: 5px;
          padding: 10px;
          display: flex;
          background-image: url("../assets/img/home/sbcountbg.png");
          background-size: 100% 100%;

          .zxitem_left {
            width: 50%;
            font-size: 18px;
            font-family: "title";
            color: #fff;
            text-align: center;

            img {
              width: 60%;
            }
          }

          .zxitem_right {
            font-size: 14px;
            color: #fff;
            padding: 10px;
            display: flex;
            flex-wrap: wrap;
            align-content: space-around;
            justify-content: center;

            .statustxt {
              width: 100%;
              text-align: center;
              color: #b6bcc7;
              cursor: pointer;
            }

            .statusnum {
              cursor: pointer;
              width: 100%;
              font-family: "title";
              color: #2680dd;
              font-size: 22px;
              text-align: center;
              margin: 5px 0;
            }

            .t2 {
              color: #f92c15;
            }
          }
        }

        table {
          width: 100%;
          height: calc(100% - 10px);
          overflow-y: auto;
          font-size: 14px;
          color: #fff;
          border-collapse: collapse;

          tr th {
            background-color: #023f7e80;
            padding: 10px 5px;
            border-right: 1px solid #007cff80;
          }

          .ai-warning-placeholder-row td {
            padding: 0;
            background-color: transparent;
            border: none;
          }

          tr td {
            padding: 10px 5px;
            background-color: #04386f50;
            text-align: center;
            border-right: 1px solid #007cff80;

            span {
              color: #2680dd;
            }

            .statusbtn {
              padding: 4px 8px;
              background-color: #f92c1510;
              color: #f92c15;
              border-radius: 4px;
            }

            .btn0 {
              background-color: #2680dd69;
              color: #2680dd;
            }
          }
        }
        .ai-warning-placeholder {
          width: 100%;
          min-height: 120px;
          display: flex;
          align-items: center;
          justify-content: center;
          font-size: 18px;
          color: #88a0c6;
          background-color: #04386f50;
          border: 1px dashed #007cff80;
        }
      }
    }

    .blbox {
      width: 25%;
    }

    .bcbox {
      width: 50%;

      .ctitle {
        justify-content: space-between;
        padding-right: 10px;

        div {
          display: flex;
          align-items: center;
        }

        img {
          margin-left: 20px;
          cursor: pointer;
        }
      }
    }

    .brbox {
      width: 25%;

      .monitor-placeholder {
        width: 100%;
        height: 100%;
        display: flex;
        align-items: center;
        justify-content: center;
        color: #88a0c6;
        font-size: 16px;
        background-color: #031730;
        border: 1px dashed #0b4fa2;
      }
    }
  }
}
</style>
